import { useQuery } from '@tanstack/react-query';
import { apiService } from '../../../services/api';
import { useTranslation } from '../../../i18n';
import { DroneStatus } from '../../../types/api';

// STD-015: server state for the Profile tab domain. apiService is imported
// here (a *.queries.ts file) per STD-016. Errors are toasted by the global
// QueryCache handler (lib/queryClient); meta.errorMessage supplies the i18n
// fallback.

export const profileKeys = {
  all: ['profile'] as const,
  droneStatus: (serial: string) => [...profileKeys.all, 'droneStatus', serial] as const,
};

export function useDroneStatusQuery(droneSerial: string | null | undefined) {
  const { t } = useTranslation();
  return useQuery({
    queryKey: profileKeys.droneStatus(droneSerial ?? ''),
    enabled: !!droneSerial,
    meta: { errorMessage: t('profileTab.failedToLoadStatus') },
    queryFn: async (): Promise<DroneStatus> => {
      const response = await apiService.getDroneStatus(droneSerial!);
      return response.status as DroneStatus;
    },
  });
}
